export default __webpack_public_path__ + "assets/sahrawi-flag.png";